import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { HOMEPAGE_NAV_CONFIG } from './base/homepage-nav-config';

export const homepageNavRoutes: Routes = [
  {
    path: HOMEPAGE_NAV_CONFIG.routePath!,
    data: { title: 'Homepage Navigation' },
    canActivate: [
      roleGuard('ADMIN_MASTER'),
      permissionGuard('HOME_SCREEN$READ'),
    ],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/homepage-nav-list-page/homepage-nav-list-page.component'
          ).then((m) => m.HomepageNavListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/homepage-nav-detail-page/homepage-nav-detail-page.component'
              ).then((m) => m.HomepageNavDetailPageComponent),
            data: { title: 'Homepage Navigation Detail' },
          },
        ],
      },
    ],
  },
];
